<app-pageheader [Parent]="this">
    <add-button AddRoute="/integrations/orikan/new/edit"></add-button>
  </app-pageheader>
  
  <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="integrations/orikan/configuration/search"
    [AllowEdit]="true" EditUrl="/integrations/orikan/:id">
    <app-filter-set>
      <div app-search-filter></div>
      <div app-search-button></div>
    </app-filter-set>
  </app-datalistview>